import React from "react";
import { Select } from "../..";
var nums = new Set(["number", "integer"]);

function processValue(value) {
  return value;
}

function getValue(value, multiple, options) {
  console.log("getValue", value, multiple, options);

  if (multiple) {
    var filtered = options.filter(function (opt) {
      return value.includes(opt.value);
    });
    console.log("getValue returned:", filtered);
    return filtered;
  } else {
    var _filtered = options.filter(function (opt) {
      return opt.value === value;
    });

    console.log("getValue returned:", _filtered);
    return _filtered;
  }
}

function onChangeWrapper(originalOnChange, value, action, multiple) {
  console.log("onChangeWrapper", value, action, multiple);

  if (multiple) {
    var selected = value.map(function (opt) {
      return opt.value;
    });
    console.log("selected", selected);
    originalOnChange(selected);
    return;
  }

  console.log("selected", value.value);
  originalOnChange(value.value);
}

function CustomSelect(props) {
  var schema = props.schema,
      id = props.id,
      options = props.options,
      value = props.value,
      required = props.required,
      disabled = props.disabled,
      readonly = props.readonly,
      multiple = props.multiple,
      autofocus = props.autofocus,
      _onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      placeholder = props.placeholder;
  var enumOptions = options.enumOptions,
      enumDisabled = options.enumDisabled;
  var emptyValue = multiple ? [] : "";
  var selectOptions = [];
  enumOptions && enumOptions.forEach(function (option) {
    selectOptions.push(option);
  });
  enumDisabled && enumDisabled.forEach(function (option) {
    selectOptions.push(Object.assign(Object.assign({}, option), {
      isDisabled: true
    }));
  });
  console.log("PROPS", props);
  return React.createElement(Select, {
    id: id,
    value: getValue(value, multiple, selectOptions),
    autoFocus: autofocus,
    isDisabled: disabled,
    onChange: function onChange(value, action) {
      return onChangeWrapper(_onChange, value, action, multiple);
    },
    isSearchable: true,
    name: "color",
    isMulti: multiple,
    options: selectOptions,
    placeholder: placeholder
  });
}

export default CustomSelect;